import React from 'react'
import Title from '../shared/Title'
import Caption from '../shared/Caption'
import Button from 'components/util/Button'
import ResponsiveImage from 'components/util/ResponsiveImage'
import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'
import styles from './_syncsLanding.css'

import mobileScreen from 'images/landing/sync/screen/mobile.png'
import desktopScreen from 'images/landing/sync/screen/desktop.png'
const screens = {
  src: mobileScreen,
  large: desktopScreen,
}

function Syncs () {
  return (
    <div className={styles.syncsWrapper}>
      <div className={styles.syncs}>
        <div className={styles.content}>
          <Title color="white">
            <FormattedMessage id='landingPage.syncs.title' defaultMessage='Sync with Under Armour Smart Shoes' />
          </Title>
          <Caption color="white">
            <FormattedMessage
              id='landingPage.syncs.caption'
              defaultMessage='Automatically track stats like distance, cadence, and stride length—with or without your phone.'
            />
          </Caption>
          <Button
            className={styles.callToAction}
            size="medium"
            type="default"
            onClick={() => { window.location.href = 'https://www.underarmour.com/en-us/ua-hovr?cid=MMF%7CREF%7CMMFitness%7CSite%7Chome_page%7CHOVR' }}
          >
            <FormattedMessage
              id='landingPage.syncs.callToAction'
              defaultMessage='Learn More'
            />
          </Button>
        </div>
        <div className={styles.screen}>
          <ResponsiveImage {...screens} />
        </div>
      </div>
    </div>
  )
}

Syncs.propTypes = {
  site: PropTypes.object,
}

export default Syncs



// WEBPACK FOOTER //
// ./src/components/landing/syncs/index.jsx